import * as React from 'react';
import ToastMessage from "@/components/ToastMessage";
import { ToastContainer } from "react-bootstrap";
import { useToasts } from '@/hooks/toasts';

const BlankLayoutProvider = ({ children }) => {
    const { toasts, removeToast } = useToasts();
    return (
        <>
            {children}
            <ToastContainer position="top-end" className="p-3 z-index-top">
                {toasts?.map((toast, index) => (
                    <ToastMessage
                        key={index}
                        onClose={() => removeToast(toast.id)}
                        message={toast.message}
                        variant={toast.variant}
                    />
                ))}
            </ToastContainer>
        </>
    );
};

export default BlankLayoutProvider;
